<template>
  <div class="preview-file preview-files">
    <div>
      <div class="file-title clearfix">
        <div class="title-left">
          <a href="javascript:void(0);" @click="fn" class="icon-back"></a>
          <i class="link-Whether" @click="like"></i>
        </div>

        <div class="title-right">
         <span v-if="item">
          <img v-if="item.user" :src="item.user.face_url" alt=""/>
          {{item.nickname,8|ellipsis}}
         </span>
        </div>
      </div>
      <div class="preview-conten preview-contenNext show-box" v-if="item" id="videoName">
        <!--播放器开始-->

        <div id="myImg" style="width: 100%;height: auto" v-if="item.image_url">
          <img :src="item.image_url" alt=""/>
        </div>
        <div id="myFlash" class="video_left" v-if="item.time_span"></div>
        <div class="preview-text show-v-box">
          <p class="file-browse">
            <span>{{visitNum}}&nbsp;浏览</span>
            <span class="gap-line">&nbsp;|&nbsp;</span>
            <i v-if="item.upload_time">{{item.upload_time|datetime}}&nbsp;上传</i>
            <i v-else>{{item.upload_datetime|datetime}}&nbsp;上传</i>
            <span class="btn-copy toCopy" @click="copyUrl">复制地址</span>

          </p>
          <h4 class="file-tle">{{item.title}}</h4>
          <p class="preview-p">
            <span class="preview-span">{{item.description}}</span>
          </p>

          <p class="show-v-more" @click="showVmore"><i class="icon-vs-show"></i></p>

          <div class="file-div">
            <p class="icon-title" v-if="activeName">
              <router-link class="icon-title" :to="'/detail/' + activeId" tag="p" v-if="activeName">     参与了【{{activeName}}】
              </router-link>
            </p>
            <p class="icon-ps"><i class="file-like"></i><span class="number numberName">{{favoriteNum}}</span> 人喜欢</p>

            <!-- <p><i class="file-leaving "></i><span class="number">{{total}}</span> 留言</p> -->
          </div>
        </div>
      </div>
      <div v-else class="yaVideo">加载中...</div>
      <div class="content detail-content"  style="margin-bottom: 60px">
        <div class="dl-message" style="padding: 0 10px;background: none">
          <!-- <div class="dl-ms-title">
             <i class="icon-message"></i>留言
           </div>-->
          <!--   <div class="dl-ms-edit">
               <i class="icon-edit"></i>我有话说
             </div>-->
          <div class="dl-ms-link">
            <div class="dl-ms" v-if="leavingName" v-for="(item,ind) in leavingName"
                 style="border-top:1px solid #ccc;padding-top: 10px">
              <!--主留言-->
              <div class="dl-ms-head">
                <div class="dl-head-pic">
                  <img :src="item.avatar" alt=""/>
                </div>
                <div class="dl-head-name">
                  {{item.author}}<span>[{{item.locale}}]</span>
                </div>
                <div class="dl-head-like">
                  <i class="icon-like"><em>+1</em></i>
                  <span>{{item.agree}}</span>
                </div>
              </div>
              <div class="dl-ms-chat">
                <div class="dl-ms-tit">
                  {{item.message}}
                </div>
              </div>
              <div class="dl-time">{{new Date().getTime()/1000 - item.dateline | timeToMillion}}</div>
            </div>
            <!-- <p class="dl-ms-more" @click="More">查看更多留言</p> -->
          </div>
        </div>
      </div>

    </div>
   <!--  <div class="dl-ms-title dl-video-title">
     <i class="icon-message icon-messages"><img :src="globalUrl + 'static/dist/img/video-file.png'" alt=""/></i>
     <span class="textarea">最多可输入120字</span>
     <textarea disabled="disabled"  class="have-word" name="" id="" cols="30" rows="10"  placeholder="我有话要说"></textarea></div> -->
    <!--提示-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="detailAlert" role="dialog" aria-hidden="true"
         style="background: rgba(0,0,0,.5)">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class="detailAlert-p" style="text-align: center;padding-top:30px;height: 80px;font-size: 18px">
              请先登录账号 </p>
            <div class="btn-modal-tw">
              <a href="javascript:void(0);" class="buttonW buttonL" @click="determine">确定</a>
              <a href="javascript:void(0);" class="buttonW buttonR" data-dismiss="modal">取消</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--提示-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="discoverAlert" role="dialog" aria-hidden="true"
         style="background: rgba(0,0,0,.5)">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class="detailAlert-p" style="text-align: center;padding-top:30px;height: 80px;font-size: 18px">
              该文件无法点赞</p>
            <div class="btn-modal-tw">
              <a href="javascript:void(0);" class="buttonZ" data-dismiss="modal">确定</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 留言 -->
    <div class="samll-info-modal modal fade" id="chatModal" role="dialog" aria-hidden="true"
         style="background: rgba(0,0,0,.5)">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <i class="icon-modal"></i>

              <p class="info-mess" style="z-index: 999">留言发布成功啦！</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--中心弹出心形-->
    <div class="heart-shaped">
      <img :src="globalUrl + 'static/dist/img/zhan.png'" alt=""/>
    </div>
    <!--message box-->
    <div class="detail-messagebox" style="position: fixed;">
      <div class="detail-messbox-inner">
        <h5>我有话说</h5>

        <div class="dl-ms-btn"></div>
        <div class="dl-ms-wrap">
          <div class="dl-ms-inner">

            <textarea id="saytext" rows="6" placeholder="最多可输入120字" maxlength="120"></textarea>
            <!-- <i class="icon-smile emotion"></i>-->
          </div>
        </div>
        <a href="javascript:void(0);" class="btn-detail-edit">
          完&nbsp;&nbsp;成
        </a>
      </div>
    </div>
    <!--登录-->
    <div class="modal-confim large-info-modal modal fade" id="login_Alert" role="dialog" aria-hidden="true"
         style="background: rgba(0,0,0,.5)">
      <div class="modal-dialog" role="document" style="margin-top: 0;width: 100%;height: 100%;">
        <div class="modal-content" style="left: -1%;top: -1%;width: 102%;height: 102%">
          <div class="modal-body">
            <LoginAler></LoginAler>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loginAler from './loginAler.vue'

  export default {
    data() {
      return {
        item: '',
        activeId: '',
        activeName: '',
        leavingName: [],
        showVmoreName: false,
        uuid: '',
        pageName: 1,
        total: 0,
        userId: '',
        nickname: '',
        uuidPlace: '',
        num: '',
        visitNum: '',
        favoriteNum: '',
        type: '',
        fileId: '',
        fileItem: '',
        globalUrl: API.GlobalUrl
      }
    }
    ,
    methods: {
      //操作按钮事件
      fn() {
        if (window.history.length <= 1) {
          this.$router.push({name: 'Discovery'});
          return false
        } else {
          this.$router.go(-1)
        }
      },
      determine() {
        $('#detailAlert').modal('hide');
        $('#login_Alert').modal('show');
        // this.$router.push({name: 'login_Quick'})
      },
      showVmore() {
        this.showVmoreName = !this.showVmoreName;
        if (this.showVmoreName) {
          $('.preview-p').css({'height': 'auto'});
          $('.show-v-more').css({'transform': 'rotate(180deg)'})
        } else {
          $('.preview-p').css({'height': '40px'});
          $('.show-v-more').css({'transform': 'rotate(0deg)'})
        }
      },
      More() {
        var pageName = ++this.page;
        this.MoreFn(pageName)
      },
      MoreFn(pageName) {
        var that = this;
        //评论渲染
        $('.dl-message').show();
        //留言
        var Leaving = {
          app: 'xiyou',
          itemid: 'ishow_' + that.uuidPlace,
          itemtype: '0',
          prepage: 10,
          avatar: 1,
          page: pageName
        };
        // console.log(Leaving)
        //xiyou
        $.getJSON('http://common.newcomment.cntv.cn/data/list?jsonp_callback=?', Leaving, function (res) {
          if (res.code == 0) {
            for (var m = 0; m < res.data.content.length; m++) {
              that.leavingName.push(res.data.content[m]);
              var pid = res.data.content[m].pid;
              var tip = res.data.content[m].tip;
              //回复列表
            }
          }
          //console.log(that.leavingName)
          that.total = res.data.total;
          if (res.data.total < 10 || that.leavingName.length == res.data.total) {
            $('.dl-ms-more').hide()
          }
        });
      },
      like() {//点赞-喜欢
        var that = this;

        if (that.type == 'no') {
          $('#discoverAlert').modal('show');
          return false;
        }
        if (that.uuid != '') {
          if ($('.link-Whether').hasClass('active')) {
            var videoFavorite = {
              file_id: that.uuid,
              op: 0
            };
            that.$http.get(API.VideoFavorite, {params: videoFavorite})
              .then(function (res) {
                $('.link-Whether').removeClass('active');
                $('.numberName').html(parseInt($('.numberName').text()) - 1)
              });
            return false;
          } else {
            var that = this;
            var videoFavorite = {
              file_id: that.uuid,
              op: 1
            };
            that.$http.get(API.VideoFavorite, {params: videoFavorite})
              .then(function (res) {
                that.linkFn(res)
              })
          }
        } else {
          if ($('.link-Whether').hasClass('active')) {
            var videoFavorite = {
              file_id: that.fileId,
              op: 0
            };
            that.$http.get(API.ImageFavorite, {params: videoFavorite})
              .then(function (res) {
                $('.link-Whether').removeClass('active');
                $('.numberName').html(parseInt($('.numberName').text()) - 1)
              });
            return false;
          } else {
            var that = this;
            var videoFavorite = {
              file_id: that.fileId,
              op: 1
            };
            that.$http.get(API.ImageFavorite, {params: videoFavorite})
              .then(function (res) {
                that.linkFn(res)
              })
          }
        }

      },
      linkFn(res) {
        var that = this;
        if (res.code == 0) {
          that.num = res.data.num;
          //动画
          $('.numberName').html(parseInt($('.numberName').text()) + 1);
          $('.link-Whether').addClass('active');
          $('.heart-shaped').show();
          $('.heart-shaped').addClass('heart-active');
          setTimeout(function () {
            $('.heart-shaped').addClass('heart-activex');
          }, 150)
          setTimeout(function () {
            $('.heart-shaped').removeClass('heart-activex');
            $('.heart-shaped').addClass('heart-active');
          }, 300);
          setTimeout(function () {
            $('.heart-shaped').removeClass('heart-active');
          }, 450)
          setTimeout(function () {
            $('.heart-shaped').fadeOut();
          }, 800);
        } else {
          $('#discoverAlert').modal('show')
        }
      },
      copyUrl(){

        var url = location.href;
        var clipboard = new ClipboardJS('.toCopy', {
            text: function(trigger) {
                return url;
            }
        });
        clipboard.on('success', function() {
          $('#chatModal .info-mess').html('复制成功啦！');
          $('#chatModal').modal('show');
          setTimeout(function () {
            $('#chatModal').modal('hide')
            clipboard.destroy();
          }, 2000);
        });

      }
    }
    ,
    components: {   //渲染页面
      LoginAler: loginAler
    },
    created: function () {
      var that = this;
      // 判断安卓机去掉动画
      that.isAndroid();
      if (that.$route.params.type == 'video') {
        that.uuid = that.$route.params.uuid || '';
      } else {
        that.fileId = that.$route.params.uuid || '';
      }
      that.activeId = that.$route.params.id;
      var getVideoInfo = '',
        APIName = '';
      if (that.uuid == '') { //图片
        getVideoInfo = {
          file_id: that.fileId,
          version: 2
        };
        APIName = API.GetImageInfo;
      } else {  //视频
        getVideoInfo = {
          file_id: that.uuid,
          version: 2
        };
        APIName = API.GetVideoInfo;
      }

      function getCookie(name) {
        var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
          return unescape(arr[2]);
        } else {
          return null;
        }
      }

      that.userId = getCookie('userSeqId');

      this.$http.get(API.GetActivitieById, {params: {id: that.activeId}})
        .then(function (res) {
          if (res.code == 0) {
            that.activeName = res.data.title;
          }
          getVideo(that)
        });

      function getVideo(that){

        that.$http.get(APIName, {params: getVideoInfo})
        .then(function (res) {
          //console.log(that.uuid);
          if (res.code == 0) {
            that.item = res.data;

            that.visitNum = res.data.visit_num; //浏览
            that.favoriteNum = res.data.favorite_num; //点赞喜欢
            that.type = 'yes';
            $('.icon-ps').show();
            that.nickname = that.item.nickname; //用户名
            if(that.activeId ==100171){
              that.item.description ='';
            }
            var dataName = '';
            if (that.uuid != '') {
              var len = $('.video_left').length;
              var W = document.documentElement.clientWidth;  //播放窗口宽度
              var H = Math.ceil(document.documentElement.clientWidth / 1.78);  //播放窗口高度
              that.VideoPlay(that.uuid, W, H, 'myFlash');
              that.uuidPlace = that.uuid.replace(/-/g, '_');

              document.title = that.item.title;
              let metas = $('head').children('meta');
              if (metas[1]) {
                metas[1].content = that.item.description;
              }
              if (res.data.thumb_url) {
                imgAdd = res.data.thumb_url;
              } else {
                imgAdd = '/images/video.jpg'
              }
              dataName = {
                title: that.item.title,  //分享标题
                // desc: that.removeTAG(that.item.description, 110),//metas[1].content,//分享简介(内容)
                desc: that.removeTAG('我参与了【'+that.activeName+'】', 110),//metas[1].content,//我参与了（活动名称）；
                imgAddress: imgAdd,//分享图片地址
                Retain: '',//保留
                url: API.UrlName + 'videoName/' + that.activeId + '/' + that.uuid + '/video'//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
              };
              // console.log(dataName)
              that.weixinShare(dataName);
            } else {
              that.uuidPlace = that.fileId.replace(/-/g, '_');
              $('#myImg').html('<img src="' + that.item.image_url + '" alt=""/>');
              document.title = that.item.title;
              let metas = $('head').children('meta');
              if (metas[1]) {
                metas[1].content = that.item.description;
              }
              var imgAdd = '';
              if (res.data.image_url) {
                imgAdd = res.data.image_url
              } else {
                imgAdd = '/images/login-img.jpg';
              }
              dataName = {
                title: that.item.title,  //分享标题
                // desc: that.removeTAG(that.item.description, 110),//metas[1].content,//分享简介(内容)
                desc: that.removeTAG('我参与了【'+that.activeName+'】', 110),//metas[1].content,//我参与了（活动名称）；
                imgAddress: imgAdd,//分享图片地址
                Retain: '',//保留
                url: API.UrlName + 'videoName/' + that.activeId + '/' + that.uuid + '/image'//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
              };
              that.weixinShare(dataName);
            }
            that.$nextTick(function () {

              if (!that.item.user) {
                $('.title-right').children('span').css('padding', '8px 10px 8px 8px')
              }
            })
          } else {
            that.type = 'no';
            $('.icon-ps').hide();
            $(".dl-ms-more").hide();
            $('.yaVideo').html('呀！作品找不到了！');
            //alert('没有对应信息');
            //that.$router.back(-1)
          }
           $('.detail-content').hide();
        });
      }
    },
    mounted: function () {
      //操作DOM
      var that = this;
      if (that.IsPC()) {
        window.location.href = API.IsPcName
      }
      setTimeout(function () {
        //获取视频信息，预览
        if (that.item && that.uuidPlace) {
          that.MoreFn(1)
        }
        if ($('.preview-p').height() > 40) {
          $('.preview-p').css({'height': '40px'});
          $('.show-v-more').show()
        } else {
          $('.show-v-more').hide()
        }

        //关闭留言框面板
        $('.dl-ms-btn').on('click', function () {
          $('#saytext').val('');
          $('#myFlash').show();
          $('.detail-messagebox').css({'top': '120%'});
        });

        // 打开留言面板
        // dl-ms-edit
        $('.dl-ms-title').on('click', function () {
          $('video')[0].pause();
          if (that.userId) {
            $('#saytext').val('');
            $('.detail-messagebox').css({'top': '0'});
            $('#myFlash').hide();
          } else {
            $('#myFlash').hide();
            $('#login_Alert').modal('show');
            return false;
          }
        });

        //查看结果留言表情
        function replace_em(str) {
          str = str.replace(/\</g, '&lt;');
          str = str.replace(/\>/g, '&gt;');
          str = str.replace(/\n/g, '<br/>');
          str = str.replace(/\[em_([0-9]*)\]/g, '<img src="../../static/dist/arclist/1.gif" border="0" />');
          return str;
        }

        function getCookie(name) {
          var arr = document.cookie.split('; ');

          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');
            if (arr2[0] == name) {
              return arr2[1];
            }
          }
          return '';
        }

        var intervaLock;
        /*发布留言*/
        $('.btn-detail-edit').on('click', function () {
          if ($('#saytext').val() != '') {
            var Leaving = {
              app: 'xiyou',
              itemid: 'ishow_' + that.uuidPlace,
              authorid: that.userId,
              author: that.nickname,
              message: $('#saytext').val()
            };
            //console.log(Leaving)
            $.ajax({
              type: 'post',
              url: 'http://newcomment.cctv.com/comment/post',
              data: Leaving,
              dataType: 'jsonp',
              xhrFields: {
                withCredentials: true
              },
              crossDomain: true,
              jsonp: 'jsonp_callback',
              success: function (res) {
                if (res.code == 0) {
                  //prepend
                  $('#myFlash').show();
                  $('.detail-messagebox').css({'top': '120%'});
                  $('#chatModal .info-mess').html('留言发布成功啦');
                  $('#chatModal').modal('show');
                  intervaLock = setTimeout(function () {
                    $('#chatModal').modal('hide')
                  }, 2000);
                } else if (res.code == '20927') {
                  var userSeqId = getCookie('userSeqId');
                  var urlHref = window.location.href;
                  var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=' +  API.UrlName + ' /index&iid=' + that.activeId + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                  window.location.href = url
                }
              },
              error: function () {
                alert('请求出错！');
              }
            });
            //  console.log(Leaving)
          }
        });
      }, 1000)
    }

  }
</script>

<style>
  body {
  }

  .preview-files {
    left: 0 !important;
  }

  .preview-file {
    position: fixed;
    top: 0;
    left: -120%;
    width: 100%;
    height: 100%;
    background: #E3E3E3; /*#f3f2f2;*/
    transition: left .3s;
    -webkit-transition: left .3s;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 1200;
  }

  .preview-file .heart-shaped {
    display: none;
    position: fixed;
    top: 22%;
    left: 50%;
    margin-top: -40px;
    margin-left: -40px;
    width: 80px;
    height: 80px;
    z-index: 999;
    transition: all 0.15s;
  }

  .preview-file .heart-shaped img {
    height: 100%;
    width: 100%;;
  }

  .preview-active {
    left: 0;
  }

  .preview-file .preview-conten {
    padding: 0;
    margin: 0;
    border: none;
    box-shadow: none;
    background: #e3e3e3;
    padding-bottom: 4px;
  }

  .file-title {
    height: 42px;
    background: #fff;
  }

  .title-left {
    line-height: 42px;
    float: left;
  }

  .title-left .icon-back {
    transform: rotate(90deg);
    background: url("../../static/dist/img/icon-video.png") 50% -172px no-repeat;
    background-size: 24px auto;
    width: 30px;
    height: 30px;
    margin-top: 7px;
    float: left;
    margin-right: 24px;
  }

  .title-left i {
    width: 30px;
    height: 34px;
    display: inline-block;
    background: url(../../static/dist/img/icon-detail.png) 50% -105px no-repeat;
    background-size: 57px auto;
    margin: 0 auto;
  }

  .title-left .active {
    background: url(../../static/dist/img/icon-detail.png) 50% -66px no-repeat;
    background-size: 57px auto;
  }

  .preview-file .heart-active {
    transform: scale(1.1);
  }

  .preview-file .heart-activex {
    transform: scale(.9);
  }

  .title-right {
    line-height: 21px;
    font-size: 14px;
    float: right;
  }

  .title-right img {
    height: 24px;
    width: 24px;
    float: left;
    margin-right: 5px;
    margin-top: -8px;
    border-radius: 50%;
  }

  .title-right span {
    float: right;
    line-height: 8px;
    background: #e8e8e8;
    padding: 8px 10px 0 0;
    border-radius: 20px;
    margin: 10px 10px 0 0;
    color: #999;
  }

  #myImg img {
    height: auto;
    width: 100%;
    min-height: 50px;
  }

  .preview-file .preview-text {
    padding: 0 10px;
  }

  .preview-file .preview-text p {
    padding: 0;
  }

  .preview-file .preview-text .file-browse {
    color: #999;
    margin-top: 5px;
    font-size: 12px;
    line-height: 1em;
  }

  .preview-file .preview-text .file-tle {
    margin: 10px 0;
    font-size: 16px;
    color: #666666;
    font-weight: 700;
  }

  .preview-file .preview-text .preview-p {
    color: #666666;
    max-height: none;
    min-height: inherit;
    overflow: hidden;
    margin-bottom: 0;
    font-size: 14px;
  }

  .file-div {
    margin-bottom: 10px;
    color: #888;
    font-size: 14px;
  }

  .file-div .number {
    display: inline-block;
  }

  .file-browse i {
    /*float: right;*/
    font-style: normal;
  }
  .file-browse .btn-copy{
    height: 16px;
    border: 1px solid;
    border-radius: 4px;
    line-height: 14px;
    padding: 0 5px;
    float: right;
  }
  .file-browse .gap-line{
    vertical-align: 2px;
  }

  .preview-file .preview-text .file-div p {
    margin-top: 10px;
    font-size: 14px;
  }

  .dl-video-title .icon-messages {
    left: 27px !important;
    top: 14px !important;
  }

  .file-div .file-like {
    width: 19px;
    height: 18px;
    display: inline-block;
    background: url(../../static/dist/img/icon-detail.png) 50% -69px no-repeat;
    background-size: 34px auto;
    margin: 1px 10px 0 0;
    float: left;
  }

  .preview-file .preview-span {
    font-size: 14px;
    line-height: 20px;
  }

  .dl-video-title {
    z-index: 12;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 58px;
    line-height: 44px;
    overflow: hidden;
    padding: 0 3%;
  }

  .dl-video-title .textarea {
    position: absolute;
    top: 5px;
    left: 3%;
    right: 3%;
    bottom: -1px;
    height: 48px;
    width: 93%;
    padding: 0 50px;
    border: 1px solid #BDBCBC;
    background: #EBEBEB;
    color: #ccc;
  }

  .icon-messages .have-word:focus {
    /*   border-color: red!important;
       -webkit-box-shadow:  none!important;
       box-shadow: none!important;*/
  }

  .preview-file .yaVideo {
    position: fixed;
    color: #999;
    top: 40%;
    font-size: 24px;
    text-align: center;
    width: 100%;
  }
  #myFlash{
    padding-top: 56.3%;
    position: relative;
    background: #333;
  }
  #myFlash video{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/videoName.vue